"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const up = async (knex)=>{
    await knex.schema.alterTable('nc_models', (table)=>{
        table.integer('mm');
        table.text('m_to_m_meta');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable('nc_models', (table)=>{
        table.dropColumns('mm', 'm_to_m_meta');
    });
};
